import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { FlatButton } from '../button/FlatButton';
import { DialogHeader } from '../dialog/DialogHeader';
import './DialogTypes.scss';

// #region Component State

const initialState = {
    open: false
};

type State = (typeof initialState);

// #endregion

// #region Component Props

interface IProps {
    title           : string;
    body            : string;
    triggerText     : string;
    triggerClass    : string;
    triggerIcon     : string;
    successCallback : any;
}

// #endregion

export class ConfirmationDialogTrigger extends React.Component<IProps, State> {

    public static defaultProps = {
        triggerIcon: ''
    };

    public state : State = initialState;
    
    public handleClickOpen = () => {
        this.setState({
            open: true
        });
    }

    public handleCancel = () => {
        this.setState({ open: false });
    }

    public handleOkay = () => {
        this.setState({
            open: false
        }, this.props.successCallback );
    }

    public render() {

        const { title, body, triggerText, triggerClass, triggerIcon } = this.props;

        const hasIcon = triggerIcon ? true : false;

        return <React.Fragment>

            <button 
                className={ "btn-clear " + triggerClass } 
                onClick={ this.handleClickOpen }>
                { hasIcon ? <i className={"la "  + triggerIcon } /> : null }
                { triggerText }
            </button>

            <Dialog
                open={this.state.open}
                onClose={this.handleCancel}
                maxWidth="md"
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1 className="confirmation-title-text">{ title }</h1>
                </DialogHeader>

                <DialogContent className="dialog-body-content">
                    <div className="row">
                        <div className="col">
                            <p className="confirmation-body-text">{ body }</p>
                        </div>
                    </div>                    
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="confirmNoBtn"
                        text="No"
                        classes="negative"
                        onBtnClick={ this.handleCancel } />
                    <FlatButton
                        id="confirmYesBtn"
                        text="Yes"
                        classes="positive"
                        onBtnClick={ this.handleOkay } />
                </DialogActions>
            </Dialog>
        </React.Fragment>;
    }
}
